import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7501afea"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 mx-2 mt-6 mb-2" }
const _hoisted_3 = { class: "switch-network-popup-label" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = { class: "switch-network-popup-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/networks/binance.svg",
  alt: "Binance",
  class: "network-btn-icon"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, " BNB Chain ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: _ctx.isVisible,
    width: "fit",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    rounded: "top-left-to-bottom-right"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "switch-network-popup-title",
        innerHTML: _ctx.$t('switch_network_popup_notification')
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('stay_on')), 1),
          _createVNode(_component_BalBtn, {
            color: "zink",
            rounded: "",
            outline: "",
            size: "sm",
            class: "network-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: `/images/networks/${_ctx.selectedNetwork.logo}`,
                alt: _ctx.selectedNetwork.name,
                class: "network-btn-icon"
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedNetwork.label), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('change_to')), 1),
          _createVNode(_component_BalBtn, {
            color: "zink",
            rounded: "",
            outline: "",
            size: "sm",
            class: "network-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.switchToBnb();
            _ctx.$emit('close');
          })
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}